export const Modules = {
    ASSETS: 'assets',
    BIZIDOCS: 'bizidocs',
    BRANDING: 'branding',
    CALENDAR: 'calendar',
    COMMUNITY_BOARD: 'community_board',
    CUSTOMERS: 'customers',
    DEPARTMENTS: 'departments',
    EMPLOYEES: 'employees',
    HOME: 'home',
    INVOICES: 'invoices',
    INVENTORY: 'inventory',
    INVENTORY_ORDERS: 'inventory_orders',
    LOCATIONS: 'locations',
    ORGANIZATION: 'organization',
    PERFORMANCE_REVIEWS: 'performance_reviews',
    PRODUCTS: 'products',
    REVIEW_TIME_CLOCKS: 'review_time_clocks',
    REVIEW_TIME_SHEET: 'review_time_sheet',
    ROLES: 'roles',
    SUBSCRIPTION: 'subscription',
    SUPPLIERS: 'suppliers',
    TIME_CLOCK: 'time_clock',
    TIME_SHEET: 'time_sheet',
    UNIT_OF_MEASURE: 'unit_of_measure',
};